"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "System";

export default {
  getHelpInfo() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetHelpInfo`).then(({ data }) =>
        resolve(data)
      );
    });
  }
};
